import { PhoneType } from "@/common/enum";
import Shared from "@/common/shared";

export class XeroPhoneModel {
  public phoneType!: PhoneType;
  public phoneNumber!: string;
  public phoneAreaCode!: string;
  public phoneCountryCode!: string;

  constructor() {
    this.phoneType = PhoneType.DEFAULT;
    this.phoneNumber = "";
    this.phoneAreaCode = "";
    this.phoneCountryCode = Shared.defaultCountryCode;
  }
}
